<template>
  <div id="app">
    <Head></Head>
    <keep-alive>
      <router-view v-if="!$route.meta.nokeep" />
    </keep-alive>
    <router-view v-if="$route.meta.nokeep" />
    <Foot></Foot>
    <transition name="fade">
      <img src="https://inclusion.oss-cn-hangzhou.aliyuncs.com/static/images/totop.png" alt="" class="to-top" @click="toTop" v-if="showTop && !$route.meta.hideTop">
    </transition>
  </div>
</template>

<script>
import protal from "@/api/protal";
import Head from './components/head.vue';
import Foot from './components/foot.vue';
export default {
  name: "App",
  components: {
    Head,
    Foot
  },
  data() {
    return {
      showTop: false
    }
  },
  mounted() {
    window.addEventListener('scroll', () => {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      const st = document.documentElement.clientHeight
      this.showTop = scrollTop > st * 3
    })
  },
  methods: {
    toTop() {
      $('html, body').animate({
          scrollTop: 0
      }, 500);
    }
  }
};

</script>

<style lang="less">
@import url('~@/assets/font/font.less');

#app {
  font-family: "Source Han Sans CN", "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-size: initial;
  transform-origin: left top;
  font-size: 14px;
}

*, *::before, *::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

img {
  display: block;
}

li,
ul {
  list-style: none;
}

.ellipsis1 {
  display: -webkit-box !important;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden !important;
}
.ellipsis2 {
  display: -webkit-box !important;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden !important;
}
.ellipsis3 {
  display: -webkit-box !important;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden !important;
}
.ellipsis4 {
  display: -webkit-box !important;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden !important;
}

.home-title {
  width: auto;
  height: 88px;
}

.el-message .el-icon-success {
  font-size: 20px;
}

.to-top {
  position: fixed;
  right: 28px;
  top: 80%;
  z-index: 10;
  background: rgba(77, 132, 255, 1);
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #fff;
  cursor: pointer;
}

@media screen and (min-width: 768px) {
  .contact-title {
      margin-bottom: 28px;
      font-family: inClusionFont;
      font-size: 44px;
      color: #FFFFFF;
      line-height: 44px;
      text-align: left;
      font-style: normal;
      text-transform: uppercase;
      white-space: nowrap;
  }
}
@media screen and (max-width: 767px) {
  .contact-title {
      font-family: inClusionFont;
      font-size: 26px;
      color: #FFFFFF;
      line-height: 26px;
      text-align: left;
      font-style: normal;
      text-transform: uppercase;
      white-space: nowrap;
  }

  .home-title {
    width: auto;
    height: 44px;
  }

  .el-select-dropdown__item {
      font-size: 12px !important;
  }
}


.move-enter-active {
    animation: move 0.2s linear;
    animation-delay: 0.01s;
    transform: translateX(100%);
}

.move-leave-active {
    animation: moveleave 0.2s linear;
}

@keyframes move {
    0% {
        transform: translateX(100%);
    }

    to {
        transform: translateX(0);
    }
}

@keyframes moveleave {
    0% {
        transform: translateX(0);
    }

    to {
        transform: translateX(100%);
    }
}


.tobottom-enter-active {
    animation: tobottom 0.2s linear;
    animation-delay: 0.01s;
    transform: translateY(100%);
}

.tobottom-leave-active {
    animation: tobottomleave 0.2s linear;
}

@keyframes tobottom {
    0% {
        transform: translateY(100%);
        opacity: 0;
    }

    to {
        transform: translateY(0);
        opacity: 1;
    }
}

@keyframes tobottomleave {
    0% {
        transform: translateY(0);
        opacity: 1;
    }

    to {
        transform: translateY(100%);
        opacity: 0;
    }
}


.fade-enter-active {
    animation: fade 0.2s linear;
    animation-delay: 0.01s;
    opacity: 0;
}

.fade-leave-active {
    animation: fadeleave 0.2s linear;
}

@keyframes fade {
    0% {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@keyframes fadeleave {
    0% {
        opacity: 1;
    }

    to {
        opacity: 0;
    }
}

@media screen and (min-width: 768px) {
  .hover-btn {
    position: relative;

    &::after {
      content: "";
      position: absolute;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: inherit;
      background: linear-gradient(to right, #125BF8, #D92793);
      transition: .3s linear;
      z-index: -1;
    }

    i {
      transition: .3s linear;
    }

    &:hover {
      i {
        transform: translateX(8px);
      }

      &::after {
        left: -8px;
        width: calc(100% + 16px);
      }
    }
  }

  .media-select {
    margin-top: 4px !important;
    background-color: #000632 !important;
    box-shadow: 0px 4px 10px 0px rgba(22,80,255,0.2) !important;
    border-radius: 12px !important;
    border: none !important;
    
    .el-select-dropdown__list {
      padding: 16px 0;
    }

    .el-select-dropdown__item {
      font-family: AlibabaPuHuiTi_2_65_Medium;
      font-size: 16px;
      color: #fff !important;
      line-height: 16px;
      padding-left: 32px;
      font-style: normal;
      display: flex;
      align-items: center;
      background: none !important;
      height: 40px;

      &.selected {
        color: #4D84FF !important;
      }
    }

    .popper__arrow {
      display: none !important;
    }
  }
}

.video-wrapper {
  position: relative;

  .video-icon {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 120px;
    height: auto;
    cursor: pointer;
  }
}
@media screen and (max-width: 767px) {
  .video-wrapper {
    .video-icon {
      width: 42px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue